import '../src/styles/global.scss';
import '../src/styles/fonts.scss';
import BasePage from './pages/home/BasePage';
import LoginPage from './pages/login/LoginPage';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import RouterPrivate from './router/RouterPrivate';
import HomePege from './pages/home/HomePage';
import PuestosPage from './pages/Puestos/PuestosPage';
import ProductPage from './pages/products/ProductPage';
import InventarioPage from './pages/inventario/InventarioPage';
import CarritoPage from './pages/venta/CarritoPage';
import CajaMenorPage from './pages/cajaMenor/CajaMenorPage';
import EmpleadoPage from './pages/empleado/EmpleadoPage';
import DetalleEmpleadoPage from './pages/empleado/DetalleEmpleadoPage';
import FacturaPage from './pages/factura/FacturaPage';
import DetalleFacturaPage from './pages/factura/DetalleFacturaPage';
import CotizacionPage from './pages/cotizacion/CotizacionPage';
import ConfiguracionPage from './pages/configuracion/ConfiguracionPage';
import CategoriaPage from './pages/configuracion/CategoriaPage';
import CambiarClavePage from './pages/configuracion/CambiarClavePage';
import UseCheckTokenExpiration from './hooks/useCheckTokenExpiration';
import ConfiguracionTipoPege from './pages/configuracion/ConfiguracionTipoPege';
import GenerarfacturaPages from './pages/pdf/GenerarfacturaPages';
import ClientesPage from './pages/configuracion/ClientesPege';
import DetalleVentaPage from './pages/ventaRapida/DetalleVentaPage';
import PdfVentaR from './pages/pdf/PdfVentaR';
import CambiarPinPage from './pages/configuracion/CambiarPinPage';
import VentasRealizadasPages from './pages/ventaRapida/VentasRealizadasPages';
import VentaRapidasPages from './pages/ventaRapida/VentasRapidasPages';
import DetalleNotasPages from './pages/agenda/DetalleNotasPages';
import NotasAgregadasPages from './pages/agenda/NotasAgregadasPages';
import CotizacionRealizadasPages from './pages/cotizacionRapida/CotizacionRealizadasPages';
import EditarFacturaPages from './pages/ventaRapida/EditarFacturaPages';
import ConfigurarUsersPege from './pages/configuracion/ConfigurarUsersPege';
import CotizacionesReaizadasPage from './pages/cotizacion/CotizacionesReaizadasPage';
import TransportePage from './pages/configuracion/TransportePage';
import EditarFacturaPage from './pages/factura/EditarFacturaPage';
import ElaboracionMaderaPage from './pages/ventaRapida/ElaboracionMaderaPage';
import AlquileresPage from './pages/alquiler/AlquileresPage';
import NuevoAlquilerPage from './pages/alquiler/NuevoAlquilerPage';
import DetalleAlquilerPage from './pages/alquiler/DetalleAlquilerPage';
import LandingPage from './pages/landing/LandingPage';
import EstadoConexionComponent from './components/EstadoConexionComponent';
import { RUTA_LANDING, RUTA_LOGIN } from './constants/rutas';




function App() {
	UseCheckTokenExpiration();
	const router = createBrowserRouter([
		{
			path: RUTA_LANDING,
			element: <LandingPage />,
		},
		{
			path: RUTA_LOGIN,
			element: <LoginPage />,
		},
		{
			path: '/base',
			element: <RouterPrivate allowedRoles={["super", "admin", "vendedor"]} component={<BasePage />} />,
		},
		{
			path: '/home',
			element: <RouterPrivate allowedRoles={["super", "admin", "vendedor"]} component={<HomePege />} />,
		},
		{
			path: '/puesto/:id',
			element: <RouterPrivate allowedRoles={["super", "admin", "vendedor"]} component={<PuestosPage />} />,
		},
		{
			path: '/producto/:id',
			element: <RouterPrivate allowedRoles={["super", "admin", "vendedor"]} component={<ProductPage />} />,
		},
		{
			path: '/inventario',
			element: <RouterPrivate allowedRoles={["super"]} component={<InventarioPage />} />,
		},
		{
			path: '/carrito',
			element: <RouterPrivate allowedRoles={["super", "admin", "vendedor"]} component={<CarritoPage />} />,
		},
		{
			path: '/carrito/:id',
			element: <RouterPrivate allowedRoles={["super", "admin", "vendedor"]} component={<CarritoPage />} />,
		},
		{
			path: '/caja-menor',
			element: <RouterPrivate allowedRoles={["super", "admin", "vendedor"]} component={<CajaMenorPage />} />,
		},
		{
			path: '/empleado',
			element: <RouterPrivate allowedRoles={["super", "admin", "vendedor"]} component={<EmpleadoPage />} />,
		},
		{
			path: '/detalleempleado/:id',
			element: <RouterPrivate allowedRoles={["super", "admin", "vendedor"]} component={<DetalleEmpleadoPage />} />,
		},
		{
			path: '/factura',
			element: <RouterPrivate allowedRoles={["super", "admin", "vendedor"]} component={<FacturaPage />} />,
		},
		{
			path: '/detallefactura/:id',
			element: <RouterPrivate allowedRoles={["super", "admin", "vendedor"]} component={<DetalleFacturaPage />} />,
		},
		{
			path: '/cotizacion',
			element: <RouterPrivate allowedRoles={["super", "admin", "vendedor"]} component={<CotizacionPage />} />,
		},

		{
			path: '/configuracion',
			element: <RouterPrivate allowedRoles={["super", "admin"]} component={<ConfiguracionPage />} />,
		},
		{
			path: '/categoria',
			element: <RouterPrivate allowedRoles={["super", "admin"]} component={<CategoriaPage />} />,
		},
		{
			path: '/cambiarclave',
			element: <RouterPrivate allowedRoles={["super", "admin"]} component={<CambiarClavePage />} />,
		},

		{
			path: '/cambiarpin',
			element: <RouterPrivate allowedRoles={["super", "admin"]} component={<CambiarPinPage />} />,
		},
		{
			path: '/configurartipo',
			element: <RouterPrivate allowedRoles={["super", "admin"]} component={<ConfiguracionTipoPege />} />
		},
		{
			path: '/generarfactura',
			element: <RouterPrivate allowedRoles={["super", "admin", "vendedor"]} component={<GenerarfacturaPages />} />
		},
		{
			path: '/generarfactura/:id',
			element: <RouterPrivate allowedRoles={["super", "admin", "vendedor"]} component={<GenerarfacturaPages />} />
		},
		{
			path: '/generarfacturaventaR/:id',
			element: <RouterPrivate allowedRoles={["super", "admin", "vendedor"]} component={<PdfVentaR />} />
		},
		{
			path: '/clientes',
			element: <RouterPrivate allowedRoles={["super", "admin"]} component={<ClientesPage />} />
		},
		{
			path: '/venta-rapida',
			element: <RouterPrivate allowedRoles={["super", "admin", "vendedor"]} component={<VentaRapidasPages />} />
		},
		{
			path: '/venta-realizadas',
			element: <RouterPrivate allowedRoles={["super", "admin", "vendedor"]} component={<VentasRealizadasPages />} />
		},
		{
			path: '/elaboracion-madera',
			element: <RouterPrivate allowedRoles={["super", "admin", "vendedor"]} component={<ElaboracionMaderaPage />} />
		},
		{
			path: '/detalle-venta/:id',
			element: <RouterPrivate allowedRoles={["super", "admin", "vendedor"]} component={<DetalleVentaPage />} />
		},
		{
			path: '/notas-agregadas',
			element: <RouterPrivate allowedRoles={["super", "admin", "vendedor"]} component={<NotasAgregadasPages />} />
		},
		{
			path: '/detalle-notas/:id',
			element: <RouterPrivate allowedRoles={["super", "admin", "vendedor"]} component={<DetalleNotasPages />} />
		},

		{
			path: '/cotizaciones-realizadas',
			element: <RouterPrivate allowedRoles={["super", "admin", "vendedor"]} component={<CotizacionRealizadasPages />} />
		},

		{
			path: '/editar-factura/:id',
			element: <RouterPrivate allowedRoles={["super", "admin", "vendedor"]} component={<EditarFacturaPages />} />
		},

		{
			path: '/users',
			element: <RouterPrivate allowedRoles={["super", "admin"]} component={<ConfigurarUsersPege />} />
		},

		{
			path: '/ver_cotizaciones',
			element: <RouterPrivate allowedRoles={["super", "admin", "vendedor"]} component={<CotizacionesReaizadasPage />} />
		},
		{
			path: '/transporte',
			element: <RouterPrivate allowedRoles={["super", "admin"]} component={<TransportePage />} />
		},
		{
			path: '/editar-factura-venta/:id',
			element: <RouterPrivate allowedRoles={["super", "admin", "vendedor"]} component={<EditarFacturaPage />} />
		},
		{
			path: '/alquileres',
			element: <RouterPrivate allowedRoles={["super", "admin", "vendedor"]} component={<AlquileresPage />} />
		},
		{
			path: '/alquileres/nuevo',
			element: <RouterPrivate allowedRoles={["super", "admin", "vendedor"]} component={<NuevoAlquilerPage />} />
		},
		{
			path: '/alquileres/:id',
			element: <RouterPrivate allowedRoles={["super", "admin", "vendedor"]} component={<DetalleAlquilerPage />} />
		},



	]);
	return (
		<>
			<RouterProvider router={router} />
			<EstadoConexionComponent />
		</>
	);
}

export default App;
